var _styled;

import styled from 'react-emotion';
import { PROPOSITION_BORDER } from 'govuk-colours';
import { MEDIA_QUERIES, SPACING } from '@govuk-react/constants';
var Li = styled('li')((_styled = {
  flex: '1 0 50%',
  width: '100%',
  listStyleType: 'none',
  margin: 0,
  padding: '3px 0',
  borderBottom: "1px solid " + PROPOSITION_BORDER
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  borderBottom: 0,
  flex: 'none',
  width: 'auto',
  paddingRight: SPACING.SCALE_3
}, _styled));
export default Li;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/top-nav/es/atoms/list-item/index.js
// module id = 301
// module chunks = 0